<template>
  <div class="flex flex-row align-items-center ml-3 mt-3 mb-1">
    <i class="pi pi-user mr-3" style="font-size: 2.5rem"></i>
    <h2 class="font-medium" v-if="employee">
      {{ employee?.code }} {{ employee?.name }}
    </h2>
    <Skeleton v-else class="w-3"></Skeleton>
  </div>
  <Divider />
  <EmployeePersonalDataFieldset
    class="w-full"
    :employee="employee"
    :formatted-birth-date="formattedBirthDate"
  />
  <Divider />
  <EmployeeContactDataFieldset :employee="employee" />
  <Divider />
  <EmployeeWorkDataFieldset
    :employee="employee"
    :formatted-joining-date="formattedJoiningDate"
    :formatted-salary-amount="formattedSalaryAmount"
  />
</template>
<script setup lang="ts">
  import { useUserStore } from '@/store'
  import { storeToRefs } from 'pinia'
  import { computed, onMounted, ref } from 'vue'
  import { EmployeeDetail } from '../models/EmployeeDetail'
  import { getEmployeeById } from '../services/EmployeeService'
  import Divider from 'primevue/divider'
  import moment from 'moment'
  import EmployeePersonalDataFieldset from '@/shared/components/employee/EmployeePersonalDataFieldset.vue'
  import EmployeeContactDataFieldset from '@/shared/components/employee/EmployeeContactDataFieldset.vue'
  import EmployeeWorkDataFieldset from '@/shared/components/employee/EmployeeWorkDataFieldset.vue'

  const { user } = storeToRefs(useUserStore())
  const employee = ref<EmployeeDetail>()

  onMounted(() => {
    if (user.value?.employeeId) {
      getEmployeeById(user.value?.employeeId).then(
        (response) => (employee.value = response)
      )
    }
  })

  const formattedBirthDate = computed(() => {
    if (employee.value?.birthDate) {
      return moment.utc(employee.value.birthDate).format('DD/MM/YYYY')
    }
    return ''
  })

  const formattedJoiningDate = computed(() => {
    if (employee.value?.joiningDate) {
      return moment.utc(employee.value.joiningDate).format('DD/MM/YYYY')
    }
    return ''
  })

  const formattedSalaryAmount = computed(() => {
    let salaryAmountString = employee.value?.salaryAmount
    return salaryAmountString
  })
</script>
